<template>
  <div>
    <AtomLoadingSecondary/>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionAcademyLegals',

  created () {
    this.$router.push(`/${this.$t('rPaths.academy')}/${this.$t('mEditionMenu.academy.legals.subject')}/${this.$t('mEditionMenu.academy.legals.children.termsAndConditions.subedition')}`)
  }
}
</script>
